<script>
	import { navigate } from "svelte-routing";

	export let errorHeader = "";
	export let errorText = "";
	export let linkText;
	export let linkTo;
</script>

<div class="alert alert-danger fade show">
	<div class="d-flex">
		<div class="me-3">
			<img src="/assets/icon-alert-filled-red.svg" alt="red-error-icon" />
		</div>
		<div>
			<div>
				<b>{errorHeader}</b>
			</div>
			<div>
				<span>
					{errorText}
				</span>
				<slot />
			</div>
		</div>
	</div>
</div>

<style>
	.alert div {
		color: black;
	}
</style>
